import {Component, attr} from "../Component";
import {element} from "../CustomElement";
import {Page} from "../flipp-page/Page";
import {i18n} from "../../i18n/I18n";
import {fetchJSON} from "../../utils/fetch";
import {orderBy, uniqBy} from "lodash-es";
import {inject} from "../../services/di";
import {ConfigService} from "../../services/ConfigService";
import {LocationService} from "../../services/LocationService";
import { renderFooter, renderSingleRow } from "../store-city-flyers/StoreCityFlyers";

export interface LinkData {
	name: string;
	link: string;
}

type FlyersCanadaModel = {
	top10Flyers: LinkData[],
	otherFlyers: LinkData[]
};

@element("flipp-flyers-canada")
export class FlyersCanada extends Component<any, any> {
	@inject config: ConfigService;
	@inject location: LocationService;

	async prepare() {
		const json = await fetchJSON(`${this.config.FLIPP_COM_APIS}/city?country=ca`);
		const top10Flyers = [] as LinkData[];
		const otherFlyers = [] as LinkData[];
		const getInCityName = (state: string, city: string) => {
			const cityName = city
				.split(" ")
				.map((c: string) => c.toLowerCase())
				.join("-");
			return `${cityName}-${state.toLowerCase()}`;
		};
		orderBy(uniqBy(json as {cityName: string, state: string}[], "cityName"), (city) => city.cityName.toLowerCase(), ["asc"]).forEach((cityState) => {
			const link = `/${getInCityName(cityState.state, cityState.cityName)}/flyers`;
			const item = { name: cityState.cityName, link };
			if (top10Cities.indexOf(cityState.cityName) >= 0) {
				top10Flyers.push(item);
			} else {
				otherFlyers.push(item);
			}
		});
		return {top10Flyers, otherFlyers} as FlyersCanadaModel;
	}

	render({top10Flyers, otherFlyers}: FlyersCanadaModel) {
		return <Page show="flyers">
			<div class="marketing link-hub">
				<div class="content-wrapper">
					<h1>{i18n("flyersCanada_title")}</h1>
					<div class="content">
						<div>{i18n("flyersCanada_content1")}</div>
						<div>{i18n("flyersCanada_content2")}</div>
						<div>{i18n("flyersCanada_content3")}</div>
						<div>
							{i18n("flyersCanada_content4_a")}
							<a href={AppleLink}> Apple </a>
							{i18n("flyersCanada_content4_or")}
							<a href={AndroidLink}> Android </a>
							{i18n("flyersCanada_content4_b")}
						</div>
					</div>
					<h2>{i18n("flyersCanada_top10")}</h2>
					<ul>
						{top10Flyers.map((flyer) => (
							renderSingleRow({
								link: flyer.link,
								text: i18n("flyer_location_title", { city: flyer.name }),
								locale: this.location.locale
							})
						))}
					</ul>
					<h2>{i18n("flyersCanada_all")}</h2>
					<div class="content">
						<div>{i18n("flyersCanada_content5")}</div>
					</div>
					<ul class="all-cities">
						{otherFlyers.map((flyer) => (
							renderSingleRow({
								link: flyer.link,
								text: i18n("flyer_location_title", { city: flyer.name }),
								locale: this.location.locale
							})
						))}
					</ul>
					<div class="content">
						<div>{i18n("flyersCanada_footnote")}</div>
					</div>
				</div>
				{renderFooter(this.location.locale)}
			</div>
		</Page>;
	}

}

const AppleLink = "https://apps.apple.com/app/flipp-weekly-shopping/id725097967";
const AndroidLink = "https://play.google.com/store/apps/details?id=com.wishabi.flipp";

const top10Cities = [
	"Kitchener",
	"Waterloo",
	"Cambridge",
	"Toronto",
	"Ottawa",
	"Montreal",
	"Halifax",
	"Winnipeg",
	"Vancouver",
	"Saskatoon",
];

